import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import HiringEventApi from '../../../../utils/api/hiringEventAPI';

const entity = new ReduxRestEntity({
  name: 'hiringEvents',
  api: HiringEventApi(),
});

export default entity;
